import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CheckoutWizardStore, createInitialState, parseCheckoutWizardObject } from './checkout-wizard.store';

@Injectable({ providedIn: 'root' })
export class CheckoutWizardService {
    constructor(
        private checkoutWizardStore: CheckoutWizardStore,
        private http: HttpClient,
    ) { }

    getCheckoutData(url: string, useDeposit: boolean) {
        this.checkoutWizardStore.update({ loaded: false });

        this.http.get<any>(url).subscribe({
            next: (data) => {
                this.checkoutWizardStore.update(parseCheckoutWizardObject(data, useDeposit));
            },
            error: () => {
                this.checkoutWizardStore.update({ loaded: true });
            }
        });
    }

    resetCheckoutData() {
        this.checkoutWizardStore.update(createInitialState());
    }

    resetStore() {
        this.checkoutWizardStore.reset();
    }
}
